import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MailerService } from '../../common/mailer/mailer.service';
import { AlertLevel, AlertsService } from '../../common/alerts/alerts.service';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

    public contactUs: FormGroup;

    private firstName: AbstractControl;
    private lastName: AbstractControl;
    private email: AbstractControl;
    private message: AbstractControl;

    constructor(formBuilder: FormBuilder,
                private readonly mailerService: MailerService,
                private readonly alertsService: AlertsService) {
        this.contactUs = formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            message: ['', Validators.required]
        });
    }

    public ngOnInit(): void {
        this.firstName = this.contactUs.get('firstName');
        this.lastName = this.contactUs.get('lastName');
        this.email = this.contactUs.get('email');
        this.message = this.contactUs.get('message');
    }

    public onSubmit() {
        // Do some basic validation, make sure we're not getting obvious garbage
        let formValid = true;
        Object.keys(this.contactUs.controls).forEach(key => {
            if (!this.contactUs.controls[key].valid) {
                this.alertsService.alert('All fields are required.', AlertLevel.Warn);
                formValid = false;
            }
        });

        if (!formValid) {
            return;
        }

        this.mailerService.sendContactSupportEmail(this.firstName.value, this.lastName.value, this.email.value, this.message.value)
            .subscribe(() => {
                this.alertsService.alert('Message sent successfully!', AlertLevel.InfoSuccess);
                this.contactUs.reset();
                // The form controls are getting set to invalid after the reset, so clear the errors
                Object.keys(this.contactUs.controls).forEach(key => {
                    this.contactUs.controls[key].setErrors(null);
                });
            },
            (error) => {
                console.log(`Got an error: ${error}`);
                if (error.status === 0) {
                    this.alertsService.alert('We could not reach the server to send the message, please try again later.', AlertLevel.InfoFailure);
                } else {
                    this.alertsService.alert('An unknown error has occurred! Please try again later', AlertLevel.InfoFailure);
                }
            }
            );
    }

}
